<h3 mat-dialog-title>Confirm Visit Cancellation</h3>
<p>Please confirm that the visit should be cancelled.</p>
<mat-dialog-actions>
  <button color="primary" mat-dialog-close mat-flat-button>Do Not Cancel</button>
  <button (click)="cancelVisit()" color="warn" mat-flat-button>Confirm Cancellation</button>
</mat-dialog-actions>
